







































import { Action } from 'vuex-class';
import { ActionMethod } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';

@Component({
  name: 'MarketRegionQuestions',
  components: {
    PerformanceWidget,
  },
})
export default class MarketRegionQuestions extends Vue {
  @Action('LIVECHAT_SHOW', { namespace: 'application' })
  protected dispatchSupportShow!: ActionMethod;

  protected openLiveChat() {
    this.dispatchSupportShow();
  }
}
